import { use } from "react";

import { ContentContext } from "lib/content/use-content";
import {
  BUFFER_SIZE,
  ContentLayoutContext,
} from "lib/layout/use-content-layout";
import { ContentNode } from "lib/types";

import { ContentNodes } from "./content-node";
import css from "./content.module.scss";

type ContentPartProps = {
  part: ContentNode[];
  partIndex?: number;
};

export function ContentPart({ part, partIndex }: ContentPartProps) {
  const { layout } = use(ContentLayoutContext)!;
  const { currentPartIndex } = use(ContentContext)!;

  const firstVisiblePartIndex = Math.max(0, currentPartIndex - BUFFER_SIZE);
  const firstPartLocation = layout?.parts[firstVisiblePartIndex];
  const isFirstPart = partIndex === firstVisiblePartIndex;
  const needsVirtualTopMargin =
    layout?.mode === "virtual" && isFirstPart && firstVisiblePartIndex > 0;
  const virtualTopMargin =
    needsVirtualTopMargin && firstPartLocation?.y
      ? firstPartLocation.y
      : undefined;

  return (
    <div className={css.part}>
      <ContentNodes content={part} firstChildMarginTop={virtualTopMargin} />
    </div>
  );
}
